import React, { useEffect, useState } from 'react'
import ComposeMail from './composeMail';
import { v4_add_mailbox_recipients, v4_delete_mailbox_recipient, v4_mailbox_compose, v4_mailbox_handleMailAction } from '../../actions/v4/mailBox';
import { toast } from 'react-toastify';
import { v2_user_for_chat } from '../../actions/v2/user';
import { getStorage, setSessionStorage } from '../../utils';
import constant from '../../constant';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import AddReipient from './addRecipient';
import { useMessageContext } from '../../context/MessageContext';

const LeftSidebar = ({ onlineUsers, mailBoxes, setMode, setSelectedMailboxId, selectedMailboxId, setChatUser, folders, selectedFolder, setSelectedFolder, host, canUseChat = true }) => {
    const { clearUnreadForUser, getUnreadCountForUser } = useMessageContext();

    const selectedCrewMailbox = (mailBoxes || []).find(
        (item) => String(item?.ID) === String(selectedMailboxId) && item?.CREW_ROLE
    );

    const handleChange = (e) => {
        setSelectedMailboxId(e.target.value);
        setSessionStorage(constant.keys.mailBox, e.target.value)
    };
    const onSendMail = async (model) => {
        try {
            let res;
            if (model.loadedDraftMessageId && !model.isDraft) {
                // If it's a loaded draft and we are sending it, use draftSend action
                res = await v4_mailbox_handleMailAction({
                    messageId: model.loadedDraftMessageId,
                    action: 'draftSend',
                    selectedMailboxId: model.id,
                    content: model.text || model.html,
                    to: (model.to || []).join(','),
                    cc: (model.cc || []).join(','),
                });
            } else {
                res = await v4_mailbox_compose(model);
                // Note: If they loaded a draft and hit "Save as Draft", it creates a new draft.
                // We could delete the old one, but we leave it for now to avoid complexity.
            }
            if (res.status) {
                toast.success(res.result?.message || 'Action successful')
                // Close the modal programmatically
                const modal = window.bootstrap.Modal.getInstance(document.getElementById('composemodal'));
                if (modal) modal.hide();
                return true;
            }

            toast.error(res.error || res.error.message)
            return false;
        } catch (error) {
            toast.error(error?.message || 'Failed to send email.')
            return false;
        }
    }

    const onAddRecipient = async (model) => {
        try {
            const res = await v4_add_mailbox_recipients(model);
            if (res.status) {
                toast.success(res.result.message)
                window.dispatchEvent(new CustomEvent('mailboxRecipientsChanged'));
                return true;
            }

            toast.error(res.error || res.error.message)
            return false;
        } catch (error) {
            toast.error(error?.message || 'Failed to add recipient.')
            return false;
        }
    }

    const onDeleteRecipient = async (id) => {
        try {
            const res = await v4_delete_mailbox_recipient(id);
            if (res.status) {
                toast.success(res.result?.message || 'Recipient deleted successfully')
                window.dispatchEvent(new CustomEvent('mailboxRecipientsChanged'));
                return true;
            }

            toast.error(res.error || res.error?.message || 'Failed to delete recipient.')
            return false;
        } catch (error) {
            toast.error(error?.message || 'Failed to delete recipient.')
            return false;
        }
    }


    const [activeUsers, setActiveUsers] = useState([]);
    const [searchUser, setSearchUser] = useState('');


    useEffect(() => {
        if (!canUseChat) {
            setActiveUsers([]);
            return undefined;
        }

        v2_user_for_chat(searchUser).then((res) => {
            if (res.status) {
                setActiveUsers(res.result)
            }
        })
    }, [canUseChat, searchUser])

    const HIDDEN_MICROSOFT_FOLDERS = new Set([
        'conversation history',
        'junk email',
        'outbox',
        'rss feeds',
        'sync issues',
    ]);

    const mapMicrosoftFolders = (folders = []) => {
        return folders
            .filter((folder) => {
                const folderName = folder?.displayName?.trim()?.toLowerCase();
                return !HIDDEN_MICROSOFT_FOLDERS.has(folderName);
            })
            .map(folder => ({
                path: folder.id,                     // used for selection
                label: folder.displayName,            // shown to user
                unread: folder.unreadItemCount || 0,  // unread count
                total: folder.totalItemCount || 0,    // total mail count
            }));
    };
    const microsoftFolders = host === 'microsoft' ? mapMicrosoftFolders(folders) : [];
    const hiddenMicrosoftFolderCount = host === 'microsoft'
        ? Math.max(0, (folders?.length || 0) - microsoftFolders.length)
        : 0;
    const chatListHeight = host === 'microsoft'
        ? Math.min(360, 203 + (hiddenMicrosoftFolderCount * 28))
        : 203;

    const iconMap = {
        "Inbox": "mdi-email-outline",
        "Sent Items": "mdi-send-outline",
        "Drafts": "mdi-file-document-outline",
        "Deleted Items": "mdi-delete-outline",
        "Archive": "mdi-archive-outline"
    };


    const getIcon = (label) => iconMap[label] || "mdi-email-outline";
    const getFolderCount = (folder = {}) => {
        if (Number.isFinite(folder.total)) return folder.total;
        if (Number.isFinite(folder.totalItemCount)) return folder.totalItemCount;
        if (Number.isFinite(folder.unread)) return folder.unread;
        if (Number.isFinite(folder.unreadItemCount)) return folder.unreadItemCount;
        return 0;
    };

    return (
        <div className="email-leftbar card">

            {/* 🔽 Dropdown */}
            <select
                className="form-select mb-2"
                value={selectedMailboxId}
                onChange={handleChange}
            >
                <option value="">Select a Mailbox</option>
                {mailBoxes?.map((item) => (
                    <option key={item.ID} value={item.ID}>
                        {item.CREW_ROLE
                            ? `${item.EMAIL} — ${item.SHIP_NAME} (as ${item.CREW_ROLE})`
                            : item.EMAIL}
                    </option>
                ))}
            </select>

            {/* Mail sent from a crew mailbox goes out as the post, not the person,
                so say which hat is on before anything is composed. */}
            {selectedCrewMailbox && (
                <div className="alert alert-warning py-2 px-2 mb-2 small">
                    Shared mailbox for <strong>{selectedCrewMailbox.SHIP_NAME}</strong>.
                    Mail you send signs as <strong>{selectedCrewMailbox.CREW_ROLE}, {selectedCrewMailbox.SHIP_NAME}</strong>.
                </div>
            )}

            {/* Compose Button */}
            <button
                type="button"
                className="btn btn-danger btn-block waves-effect waves-light mb-2   "
                data-bs-toggle="modal"
                data-bs-target="#composemodal"
            >
                Compose
            </button>



            <button
                type="button"
                className="btn btn-dark btn-block waves-effect waves-light"
                data-bs-toggle="modal"
                data-bs-target="#addRecipent"
            >
                Add Recipients
            </button>

            <div
                className="modal fade"
                id="addRecipent"
                tabIndex="-1"
                aria-labelledby="addRecipentTitle"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered" style={{ minWidth: '700px' }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addRecipentTitle">Add Recipients</h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <AddReipient
                            onAddRecipient={onAddRecipient}
                            onDeleteRecipient={onDeleteRecipient}
                        />
                    </div>
                </div>
            </div>
            {/* Compose Modal (no inline styles or manual "show" class) */}
            <div
                className="modal fade"
                id="composemodal"
                tabIndex="-1"
                aria-labelledby="composemodalTitle"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered" style={{ minWidth: '700px' }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="composemodalTitle">New Message</h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <ComposeMail
                            mailBoxes={mailBoxes}
                            onSendMail={onSendMail}
                        />
                    </div>
                </div>
            </div>
            <div className="mail-list mt-4">
                {host && host !== 'microsoft' && folders.map((folder) => {
                    const iconMap = {
                        "INBOX": "mdi-email-outline",
                        "All Mail": "mdi-email-multiple-outline",
                        "Bin": "mdi-delete-outline",
                        "Drafts": "mdi-file-document-outline",
                        "Important": "mdi-label-outline",
                        "Sent Mail": "mdi-send-outline",
                        "Spam": "mdi-alert-circle-outline",
                        "Starred": "mdi-star-outline"
                    };

                    const iconClass = iconMap[folder.label] || "mdi-email-outline";

                    return (
                        <a
                            href="javascript:void(0);"
                            key={folder.path}
                            className={`d-flex align-items-center justify-content-between py-2 ${folder.path === selectedFolder ? "active" : ""}`}
                            onClick={() => {
                                setSelectedFolder(folder.path);
                                setMode('mail');
                            }
                            }

                        >
                            <span>
                                <i className={`mdi ${iconClass} me-2`} />
                                {folder.label.charAt(0).toUpperCase() + folder.label.slice(1).toLowerCase()}

                            </span>
                            <span>({getFolderCount(folder)})</span>
                        </a>
                    );
                })}

                {host === 'microsoft' &&
                    microsoftFolders.map((folder) => {

                        const iconClass = getIcon(folder.label);

                        return (
                            <a
                                href="javascript:void(0);"
                                key={folder.path}
                                className={`d-flex align-items-center justify-content-between py-2 ${folder.path === selectedFolder ? "active" : ""
                                    }`}
                                onClick={() => {
                                    setSelectedFolder(folder.path);
                                    setMode('mail');
                                }}
                            >
                                <span className="d-flex align-items-center">
                                    <i className={`mdi ${iconClass} me-2`} />
                                    {folder.label}
                                </span>

                                <span>({getFolderCount(folder)})</span>
                            </a>
                        );
                    })
                }


            </div>

            {canUseChat && (
                <>
                    <h6 className="mt-4">Chat</h6>
                    <div className="input-group mt-2">
                        <span className="input-group-text">
                            <i className="mdi mdi-magnify" />
                        </span>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search users"
                            value={searchUser}
                            onChange={(e) => setSearchUser(e.target.value)}
                        />
                    </div>
                    <div className="mt-3" style={{ height: `${chatListHeight}px`, overflowY: 'auto' }}>
                        {activeUsers.map((user, index) => {
                            const unreadCount = getUnreadCountForUser(user.USER_ID);
                            return (
                                <a
                                    key={index}
                                    href="#"
                                    className="d-flex align-items-center mb-2 p-1"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setMode("chat");
                                        setChatUser(user);
                                        clearUnreadForUser(user.USER_ID);
                                    }}
                                >
                            <div className="position-relative flex-shrink-0 me-3">
                                <img
                                    className="rounded-circle"
                                    style={{ width: "45px", height: "45px", objectFit: "cover" }}
                                    src={
                                        user.PROFILE_IMAGE_URL
                                            ? process.env.REACT_APP_BASE_URL + user.PROFILE_IMAGE_URL
                                            : "/assets/images/user-logo.png"
                                    }
                                    alt="User"
                                />
                                {/* ✅ Status dot fixed */}
                                <span
                                    className="position-absolute rounded-circle"
                                    style={{
                                        width: "10px",
                                        height: "10px",
                                        backgroundColor: onlineUsers?.includes(Number(user.USER_ID))
                                            ? "green"
                                            : "red",
                                        border: "2px solid white",
                                        bottom: "2px",
                                        right: "2px",
                                    }}
                                ></span>
                            </div>
                            <div className="flex-grow-1 chat-user-box">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="user-title m-0 fw-bold">{user.FULL_NAME}</p>
                                    {unreadCount > 0 && (
                                        <span className="badge rounded-pill bg-danger ms-2">
                                            {unreadCount > 9 ? '9+' : unreadCount}
                                        </span>
                                    )}
                                </div>
                                <p className="text-muted m-0" style={{ fontSize: "0.85rem" }}>
                                    {user.ROLE_NAME}
                                </p>
                            </div>
                                </a>
                            );
                        })}
                        {activeUsers.length === 0 && (
                            <p className="text-muted mb-0">No users found.</p>
                        )}
                    </div>
                </>
            )}
        </div >

    )
}

export default withRouter(LeftSidebar)
